import React, { useEffect, useState } from 'react';
import { useViewport } from '../../contexts/ViewportContext';

interface ProjectSwitchAnimationProps {
  projectName: string | null;
}

export function ProjectSwitchAnimation({ projectName }: ProjectSwitchAnimationProps) {
  const { isMobile } = useViewport();
  const [visibleName, setVisibleName] = useState<string | null>(null);
  
  // Use an effect to animate the transition without timeouts
  useEffect(() => {
    if (projectName) {
      // When a new name comes in, show it immediately
      setVisibleName(projectName);
    }
  }, [projectName]);

  // Don't show on mobile or when no visible name is provided
  if (isMobile || !visibleName) return null;

  // We'll rely fully on the animationend event to clean up
  return (
    <div
      className="fixed inset-0 flex items-center justify-center pointer-events-none z-[1000]"
      style={{ top: '30px', bottom: 'auto' }}
    >
      <div 
        className="bg-blue-700 bg-opacity-85 rounded-xl px-4 py-2 shadow-xl animate-fade-in-out"
        onAnimationEnd={() => setVisibleName(null)}
      >
        <h2 className="text-2xl font-semibold text-white whitespace-nowrap">{visibleName}</h2>
      </div>
    </div>
  );
}

export default ProjectSwitchAnimation;
